<template>
  <section class="padding">
      <div class="background flex">
<div class="left-container">
    <h1>Make yoga a part of your life <br>
& subscribe to our newsletters</h1>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. </h4>
 <!-- <button>Subscribe</button> -->
</div>
<div class="right-container">
    
   <div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >Enter your email</label>
    </div>
</div>
    <button>Subscribe</button>
</div>
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
/* 
.right-container{
    display: flex;
    flex-direction: column;
} */

.wrapper{
  /* width: 380px; */
  background: #60993E;
  padding: 20px;
  /* box-shadow: 0px 0px 10px rgba(0,0,0,0.1); */
}
.wrapper .input-data{
  height: 40px;
  width: 100%;
  position: relative;
}
.wrapper .input-data input{
  height: 100%;
  width: 100%;
  border: none;
  font-size: 17px;
  border-bottom: 2px solid #FFFFF2;
      outline: none;
      background-color: #60993E;
      color: #FFFFF2;
}
.input-data input:focus ~ label
{
  transform: translateY(-20px);
  font-size: 15px;
  color: #FFFFF2;
}
.input-data input:valid ~ label{
 transform: translateY(-20px);
  font-size: 15px;
  color: #FFFFF2;
}
.wrapper .input-data label{
  position: absolute;
  bottom: 10px;
  left: 0;
  color: #FFFFF2;
  pointer-events: none;
  transition: all 0.3s ease;
}
.input-data .underline{
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0;
}
.input-data .underline:before{
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background: #FFFFF2;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}
.input-data input:focus ~ .underline:before,
.input-data input:valid ~ .underline:before{
  transform: scaleX(1);
}
.padding{
    margin-top: 150px;
}

button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ff8000de;
}
.right-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 245px;
}
.left-container{
      display: flex;
      flex-direction: column;
align-items: flex-start;
    justify-content: space-evenly;
    height: 411px;

    }

.flex{
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
}
/* input[type=text] {
  width: 20%;
  padding: 12px 137px;
  margin: 8px 0;
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid white;
  background-color: transparent;
  outline: none;
}
label{
    color: white;
    position: absolute;
} */
h4{
    color: white;
    font-weight: 500;
    line-height: 200%;
    padding-bottom: 34px;
}

h1{
    color: white;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    font-size: 3rem;
}

.background{
height: 368px;
    width: 95%;
    margin: auto;
background-color: #60993E;
border-radius: 30px;
flex-wrap: wrap;
}

@media (max-width: 1200px){
    .background{
        height: auto;
    }
    h4{
        text-align: center;
        padding: 0 15px;
        padding-top: 15px;
    }
    h1{
        text-align: center;
        /* padding: 0 15px; */
        padding-top: 10px;
        font-size: 30px;
        /* padding-left: 10px;
        padding-right: 10px; */
    }
    .left-container{
        align-items: center;
    }
}
</style>